module.exports = __webpack_public_path__ + "media/images/veramark-dd104054e39e546876a91d93d836c622.png";